export const analyticsConfig = {
  "sections": [
    {
      "sectionName": "Landing Page",
      "status": "enabled",
      "events": [
        {
          "name": "Landing Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Get Started Clicked",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Login Clicked",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Login Page",
      "status": "enabled",
      "events": [
        {
          "name": "Login Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Login Attempt",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Login Success",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Login Failure",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Recover Password Clicked",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Recover Password",
      "status": "enabled",
      "events": [
        {
          "name": "Recover Password Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Password Recovery Requested",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Password Recovery Email Sent",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Create Password",
      "status": "enabled",
      "events": [
        {
          "name": "Create Password Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Password Created",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Subscription Page",
      "status": "enabled",
      "events": [
        {
          "name": "Subscription Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Hardware Bundle Selected",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Subscription Details Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Personal Information Page",
      "status": "enabled",
      "events": [
        {
          "name": "Personal Info Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Personal Info Form Submitted",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Personal Info Form Error",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Choose Your Path",
      "status": "enabled",
      "events": [
        {
          "name": "Choose Your Path Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Choose Your Path Regular Signup Clicked",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Choose Your Path Wizard Clicked",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Choose Your Path Back Clicked",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Business Information",
      "status": "enabled",
      "events": [
        {
          "name": "Business Info Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Business Name Entered",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Business License Uploaded",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Business Info Form Submitted",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Email Verification",
      "status": "enabled",
      "events": [
        {
          "name": "Email Verification Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Email Verified Successfully",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Email Verification Failed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Resend Verification Email",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Business Information 2",
      "status": "enabled",
      "events": [
        {
          "name": "Business Info 2 Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Business Info 2 Form Submitted",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Business Info 2 eWIC and EBT Info",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Banking Information",
      "status": "enabled",
      "events": [
        {
          "name": "Bank Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Bank Details Entered",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Bank Details popup loaded",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Bank Details popup error",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Bank Information Submitted",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Bank Details Polling Error",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Software Plans",
      "status": "enabled",
      "events": [
        {
          "name": "Software Plans Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Software Plan Selected",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Software Plans Submitted",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Software Features",
      "status": "enabled",
      "events": [
        {
          "name": "Software Features Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Software Feature Category Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Software Feature Selected",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Software Features Submitted",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "NRS Pay Plans",
      "status": "enabled",
      "events": [
        {
          "name": "NRSPAY Plans Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "NRSPAY Plan Selected",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "NRSPAY Plan Submitted",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Equipment Services",
      "status": "enabled",
      "events": [
        {
          "name": "Equipment Services Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Equipment Option Selected",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Equipment Item Selected",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Equipment Item Removed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Clear All Items",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Promo Applied",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Equipment Page Submitted",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }

      ]
    },
    {
      "sectionName": "Summary",
      "status": "enabled",
      "events": [
        {
          "name": "Summary Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Order Details Expanded",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Payment Plans",
      "status": "enabled",
      "events": [
        {
          "name": "Payment Plans Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Monthly Plan Selected",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Annual Plan Selected",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Payment Method Selected",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Payment Details Submitted",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Agreements",
      "status": "enabled",
      "events": [
        {
          "name": "Agreements Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "POS Contract Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "POS Contract Signed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "NRSPAY Contract Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "NRSPAY Contract Signed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Agreement Accepted",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Success Page",
      "status": "enabled",
      "events": [
        {
          "name": "Success Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Wizard",
      "status": "enabled",
      "events": [
        {
          "name": "Wizard Started",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Wizard Question Answered",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Best Fit Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Wizard Completed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Account Portal",
      "status": "enabled",
      "events": [
        {
          "name": "Account Portal Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Order Summary Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Failed Payments Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Next Billings Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Customer Stores Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Store Search Performed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    },
    {
      "sectionName": "Error Page",
      "status": "enabled",
      "events": [
        {
          "name": "Error Page Viewed",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Error Details Expanded",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        },
        {
          "name": "Return To Home Clicked",
          "enabled": true,
          "providers": ["MixPanel", "Google Analytics"]
        }
      ]
    }
  ]
}
